import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import ClientDetails from './ClientDetails';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .clients()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={ClientDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('client', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
